export default "__VITE_ASSET__BT7HWj4A__"